module.exports = "data:image/svg+xml,module.exports = '../fonts/slick.svg';"